import { CloseOutlined, HourglassOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, message } from 'antd';
import DataDisplay from '../../../components/base/data-display/data-display-selector';
import teamMembersService from '../../../services/team-members.service';
import ActionsMenu from '../../../components/base/data-display/actions-menu';
import { AiOutlineRedo } from 'react-icons/ai';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
dayjs.extend(relativeTime);

const InvitationItemFactory =
	invitationStatusMap =>
	({ item }) => {
		return (
			item && (
				<>
					<div
						className="d-flex flex-column justify-content-center align-items-center"
						style={{ width: '36%' }}
					>
						<Avatar shape="square" size={40} icon={<UserOutlined />} />
						<span style={{ fontWeight: 500 }}>
							{item.firstName} {item.lastName}
						</span>
					</div>

					<div
						className="w-100 d-flex flex-column align-items-center justify-content-center"
						style={{ marginLeft: '-8%' }}
					>
						<span>{item.email}</span>
						<span>{dayjs(item.sentAt).format('DD/MM/YYYY')}</span>
						<span>{dayjs(new Date(item.expiresAt)).fromNow()}</span>
						<span>{item.role}</span>
						<span>{invitationStatusMap[item.status]}</span>
					</div>
				</>
			)
		);
	};

const TeamMembersInvitations = ({ data, onInvitationResend, loading }) => {
	const invitationStatusMap = {
		pending: (
			<div className="d-flex ">
				<HourglassOutlined style={{ color: '#ffcc00', fontSize: '1.25rem', marginRight: '5px' }} />
				<span>Pending</span>
			</div>
		),

		expired: (
			<div className="d-flex ">
				<CloseOutlined style={{ color: '#f5222d', fontSize: '1.25rem', marginRight: '5px' }} />
				<span>Expired</span>
			</div>
		)
	};

	const actionsFactory = item => {
		return [
			{
				name: 'Resend',
				key: 'resend',
				action: async () => {
					try {
						var resp = await teamMembersService.resendTeamMemberInvitation(item.id);
						if (!resp || !resp.success) throw new Error('');
					} catch (e: any) {
						message.error(e);
						console.error(e);
						return;
					}
					onInvitationResend && onInvitationResend(resp.data);
				},
				icon: <AiOutlineRedo />
			}
		];
	};

	const tableColumns = [
		{
			title: (
				<span className="d-inline-block ps-3 py-1" style={{ color: '#8DABC4' }}>
					Email
				</span>
			),
			dataIndex: 'name',
			key: 'name',
			render: (text, record) => (
				<div className="d-flex align-items-center">
					{/* <Avatar shape="square" size={40} icon="user" /> */}
					<span className="ps-3 d-flex flex-column">{record.email}</span>
				</div>
			)
		},
		{
			title: (
				<span className="d-inline-block ps-3 py-1" style={{ color: '#8DABC4' }}>
					Role
				</span>
			),
			dataIndex: 'role',
			key: 'role',
			render: (text, record) => <span className="ps-3">{text}</span>
		},
		{
			title: (
				<span className="d-inline-block ps-3 py-1" style={{ color: '#8DABC4' }}>
					Sent At
				</span>
			),
			dataIndex: 'createdAt',
			key: 'createdAt',
			render: (text, record) => <span className="ps-3">{text ? dayjs(text).format('DD/MM/YYYY') : 'NA'}</span>
		},
		{
			title: (
				<span className="d-inline-block ps-3 py-1" style={{ color: '#8DABC4' }}>
					Expiry
				</span>
			),
			dataIndex: 'expiresAt',
			key: 'expiresAt',
			render: (text, record) => (
				<span className="d-inline-block ps-3">{text ? dayjs(new Date(text)).fromNow() : 'NA'}</span>
			)
		},
		{
			title: (
				<span className="d-inline-block ps-3 py-1" style={{ color: '#8DABC4' }}>
					Invtation Status
				</span>
			),
			dataIndex: 'status',
			key: 'status',
			render: (text, record) => <span className="d-inline-block ps-3">{invitationStatusMap[text]}</span>
		},
		{
			title: (
				<span className="d-inline-block py-2" style={{ color: '#8DABC4' }}>
					Actions
				</span>
			),
			key: 'actions',
			render: (text, record) => <ActionsMenu dotsOrientation="horizontal" options={actionsFactory(record)} />
		}
	];

	return (
		<DataDisplay
			className="ta-table"
			data={data}
			mobileData={[data]}
			loading={loading}
			tableColumns={tableColumns}
			listItemComponent={InvitationItemFactory(invitationStatusMap)}
			renderActions={actionsFactory}
			size="small"
			pagination={{ position: 'bottom' }}
		/>
	);
};

export default TeamMembersInvitations;
